import {Checkbox, DefaultButton, Panel, PanelType} from "@fluentui/react";
import React, {ChangeEvent, FormEvent, useEffect, useState} from "react";
import {TextField} from "@fluentui/react/lib/TextField";

import {IPlan, TGuid} from "../../model/FlexibleAttributeModel";
const PlanDesign  = (props: any) => {
    const [planString, setPlanDesign] = useState<string>("")
    const[clientNumber, setClientNumber] = useState<string>("")
    const [selectedPlans, setSelectedPlans] = useState<TGuid[]>([])

    const onChangePlansCheckbox = (ev: any, checked: boolean | undefined, token: string) => {
        const value = token;
        if (checked) {
            selectedPlans.push(value);
        } else {
            setSelectedPlans(prev => prev.filter(x => x !== value));
        }
    };
    useEffect(() => {
            setPlanDesign("");
    }, [props.isOpen]);
    return  (
        <Panel
            isOpen={props.isOpen}
            onDismiss={props.dismissPanel}
            type={PanelType.medium}
            closeButtonAriaLabel="Close"
            headerText="Update Pharmacy Plan Design">
            <TextField
                label=""
                defaultValue={planString}
                onChange={(event, value) => {setPlanDesign(value || "")}}
                value={planString}
            />
            {props.bulk &&
                props.plans?.map((p: IPlan) => {
                   return (<Checkbox
                        label={p.name}
                        defaultChecked={false}
                        onChange={(ev, checked) => onChangePlansCheckbox(ev, checked, p.id)}
                        key={p.id}
                    />)
                })
            }
            <DefaultButton onClick={() => { props.bulk ? props.onSave(planString, selectedPlans) : props.onSave(planString) }} text={'Update Pharmacy Plan Design'} />
            <TextField
                label="Client Number"
                defaultValue={clientNumber}
                onChange={(event, value) => { setClientNumber(value || "") }}
                value={clientNumber}
            />
            <DefaultButton onClick={() => { props.onClientNumberUpdate(clientNumber) }} text={'Update Client Number'} />
        </Panel>
    );
}

export default  PlanDesign;